import { createSlice } from '@reduxjs/toolkit'

import { IRedeemReducers, IRedeemState } from './redeem.types'
import { RedeemStepsE } from 'types'

const initialState: IRedeemState = {
  loading: false,
  error: '',
  amountToRedeem: 1,
  burnFormValues: null,
  isApprovedForAll: false,
  isBurned: false,
  isApprovedForAllLoading: false,
  isApprovedForAllError: '',
  currentStep: RedeemStepsE.START_ALLOWANCE,
  redeemEventLoading: false,
  redeemEventError: '',
  redeemRewardLoading: false,
  redeemRewardError: '',
  txHash: '' as `0x${string}`,
}

const redeemSlice = createSlice<IRedeemState, IRedeemReducers, string>({
  name: 'redeem',
  initialState,
  reducers: {
    setTxHash: (state, action) => {
      state.txHash = action.payload
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload
    },
    setRedeemError: (state, action) => {
      state.error = action.payload
    },
    setAmountToRedeem: (state, action) => {
      state.amountToRedeem = action.payload
    },
    setBurnFormValues: (state, action) => {
      state.burnFormValues = action.payload
    },
    redeemEventRequest: (state) => {
      state.redeemEventLoading = true
    },
    redeemEventSuccess: (state) => {
      state.redeemEventLoading = false
    },
    redeemEventFailure: (state, { payload }) => {
      state.redeemEventLoading = false
      state.redeemEventError = payload
    },
    redeemRewardRequest: (state) => {
      state.redeemRewardLoading = true
    },
    redeemRewardSuccess: (state) => {
      state.redeemRewardLoading = false
    },
    redeemRewardFailure: (state, { payload }) => {
      state.redeemRewardLoading = false
      state.redeemRewardError = payload
    },
    checkEventAllowanceRequest: (state) => {
      state.isApprovedForAllLoading = true
    },
    checkEventAllowanceSuccess: (state, { payload }) => {
      state.isApprovedForAllLoading = false
      state.isApprovedForAll = payload.isApprovedForAll
    },
    checkEventAllowanceFailure: (state, { payload }) => {
      state.isApprovedForAllLoading = false
      state.isApprovedForAllError = payload.error
    },
    checkRewardAllowanceRequest: (state) => {
      state.isApprovedForAllLoading = true
    },
    checkRewardAllowanceSuccess: (state, { payload }) => {
      state.isApprovedForAllLoading = false
      state.isApprovedForAll = payload.isApprovedForAll
    },
    checkRewardAllowanceFailure: (state, { payload }) => {
      state.isApprovedForAllLoading = false
      state.isApprovedForAllError = payload.error
    },
    resetRedeemProgress: (state) => {
      state.amountToRedeem = 1
      state.isApprovedForAll = false
      state.isBurned = false
      state.isApprovedForAllError = ''
      state.currentStep = RedeemStepsE.CHECK_ALLOWANCE
      state.redeemEventError = ''
      state.error = ''
    },
    tryAgain: (state) => {
      state.currentStep = RedeemStepsE.CHECK_ALLOWANCE
      state.error = ''
    },
  },
})

export const RedeemActions = redeemSlice.actions
export const redeemReducer = redeemSlice.reducer
